export {
  BUDGETS,
  type Budget,
  type ContactApi,
  type ContactRequest,
  type ContactResponse,
  contactRequestSchema,
  contactResponseSchema,
  createContactApi,
  ENGAGEMENT_TYPES,
  type EngagementType,
  TIMINGS,
  type Timing,
} from './contact.js';
export { ApiError, type ApiErrorKind, type FieldError, isApiError } from './errors.js';
export {
  CORRELATION_HEADER,
  createHttpClient,
  type HttpClient,
  type HttpClientOptions,
  type RequestOptions,
} from './http.js';

import { type ContactApi, createContactApi } from './contact.js';
import { createHttpClient, type HttpClientOptions } from './http.js';

export interface PortfolioApi {
  contact: ContactApi;
}

/** Single entry point the app uses; never construct the sub-clients directly. */
export function createApiClient(options: HttpClientOptions): PortfolioApi {
  const http = createHttpClient(options);
  return { contact: createContactApi(http) };
}
